import { Flex } from '@folksam/ui-next/components';
import React from 'react';
import Button from '../components/Button';

export default function ButtonContainer({ buttonText }) {
    return (
        <Flex sx={{ justifyContent: 'center' }} marginTop={'6'}>
            <Button
                variant={`green`}
                sx={{
                    width: ['100%', null, null, 'fit-content']
                }}
            >
                {buttonText}
            </Button>
        </Flex>
    );
}
